import React, { memo, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectEventTypeFilterContent,
  makeSelectEventTypeFilterDataArray,
  makeSelectEventTypeFilterId,
} from '../selectors';
import { loadCourses } from '../../App/actions';
import { setEventTypeFilterDataArray, setEventTypeFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import FilterElementRadio from '../../../components/FilterElement/FilterElementRadio';

export const Items = ({
  eventTypeItems,
  onSetEventTypeFilterId,
  onLoadCourses,
  eventTypeFilterId,
  eventTypeFilterDataArray,
  onSetEventTypeFilterDataArray,
}) => {
  useEffect(() => {
    onLoadCourses();
  }, [eventTypeFilterId]);

  const toggleFilterIds = (item) => {
    const itemIndex = eventTypeFilterId.indexOf(item.id);
    if (itemIndex >= 0) {
      onSetEventTypeFilterId([...eventTypeFilterId.slice(0, itemIndex), ...eventTypeFilterId.slice(itemIndex + 1)]);
      onSetEventTypeFilterDataArray([
        ...eventTypeFilterDataArray.slice(0, itemIndex),
        ...eventTypeFilterDataArray.slice(itemIndex + 1),
      ]);
    } else {
      onSetEventTypeFilterId([item.id, ...eventTypeFilterId]);
      onSetEventTypeFilterDataArray([item.name, ...eventTypeFilterDataArray]);
    }
  };

  if (eventTypeItems.length === 0) {
    return <></>;
  }

  return eventTypeItems.map((entry) => {
    const item = Object.entries(entry)[0];
    return (
      <div key={item[1].id} onClick={() => toggleFilterIds(item[1])}>
        <FilterElementRadio
          title={item[1].name}
          status={eventTypeFilterId.indexOf(item[1].id) >= 0}
          bubble={''}
          position={0}
        />
      </div>
    );
  });
};

Items.propTypes = {
  onLoadCourses: PropTypes.func,
  eventTypeItems: PropTypes.array,
  onSetEventTypeFilterId: PropTypes.func,
  onSetEventTypeFilterDataArray: PropTypes.func,
  eventTypeFilterId: PropTypes.array,
  eventTypeFilterDataArray: PropTypes.array,
};

Items.defaultProps = {
  onLoadCourses: () => {},
  eventTypeItems: [],
  onSetEventTypeFilterId: () => {},
  onSetEventTypeFilterDataArray: () => {},
  eventTypeFilterId: [],
  eventTypeFilterDataArray: [],
};

const mapStateToProps = createStructuredSelector({
  eventTypeItems: makeSelectEventTypeFilterContent(),
  eventTypeFilterId: makeSelectEventTypeFilterId(),
  eventTypeFilterDataArray: makeSelectEventTypeFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onSetEventTypeFilterId: (value) => dispatch(setEventTypeFilterId(value)),
    onSetEventTypeFilterDataArray: (value) => dispatch(setEventTypeFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Items);
